// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__1_dj9","Success":"Button__Success__1b9yv","Danger":"Button__Danger__3BYAm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/UI/Button/Button.css
// module id = 140
// module chunks = 3